import InternalNoteCard from '@components/internalNote/InternalNoteCard'
import LoyaltyTier from '@components/loyaltyTier/LoyaltyTier'
import { User } from '@components/user/User'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import {
  getUserWithId,
  selectSelectedUser,
  updateLoyaltyTiers,
  updateUser,
} from '@store/UserReducer'
import { SBAsyncSelect } from '@supplement-bacon/react-async-select'
import { PageTitle } from '@supplement-bacon/react-toolkit/components'
import { SBRM, SBRMAction } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import {
  App,
  Card,
  Col,
  Descriptions,
  Flex,
  Form,
  Row,
  Space,
  Spin,
} from 'antd'
import { useState } from 'react'
import { DEFAULT_SUCCESS } from '../../../App'

const InformationsTab = () => {
  const { message } = App.useApp()
  const dispatch = useAppDispatch()

  const [isLoading, setIsLoading] = useState<boolean>(false)

  const user = useAppSelector(selectSelectedUser())

  if (!user) {
    return <Spin />
  }

  const handleLoyaltyTiersChange = (values: number[]) => {
    setIsLoading(true)
    dispatch(updateLoyaltyTiers({ ...user, loyaltyTiers: values }))
      .then(() => {
        message.success(DEFAULT_SUCCESS)
        dispatch(getUserWithId(user.id))
      })
      .finally(() => setIsLoading(false))
  }

  return (
    <Row gutter={[32, 32]}>
      <Col span={24}>
        <Row gutter={[32, 32]}>
          <Col sm={12} xs={24}>
            <Flex vertical gap={32}>
              <Space orientation="vertical" className="w-full" size={10}>
                <PageTitle
                  level={5}
                  title={'Client informations'}
                  style={{ margin: 0 }}
                  toolbar={
                    <SBRM.Actions
                      entity={Entity.user}
                      entityId={user.id}
                      actions={[SBRMAction.Update]}
                    />
                  }
                />
                <Card>
                  <Space className="w-full" orientation="vertical">
                    <Descriptions column={2} layout="vertical" size="small">
                      <Descriptions.Item label="First name">
                        {user.firstName}
                      </Descriptions.Item>
                      <Descriptions.Item label="Last name">
                        {user.lastName}
                      </Descriptions.Item>
                      <Descriptions.Item label="Email">
                        {user.email}
                      </Descriptions.Item>
                      <Descriptions.Item label="Phone">
                        {user.phone}
                      </Descriptions.Item>
                    </Descriptions>
                    <Descriptions column={1} layout="vertical" size="small">
                      <Descriptions.Item label="Loyalty tiers">
                        <Flex wrap gap={5} className="w-full">
                          <Form
                            className="w-full"
                            layout="horizontal"
                            initialValues={{
                              loyaltyTiers: user.loyaltyTiers,
                            }}
                          >
                            <Form.Item
                              name={'loyaltyTiers'}
                              noStyle
                              className="w-full"
                            >
                              <SBAsyncSelect
                                style={{ width: '100%' }}
                                multiple
                                entity={Entity.loyaltyTiers}
                                allowClear
                                disabled={isLoading}
                                inlineEdit={{
                                  renderSelection: () =>
                                    (user.loyaltyTiers ?? []).map(
                                      (loyaltyTier) => (
                                        <LoyaltyTier.Tag
                                          key={loyaltyTier}
                                          id={loyaltyTier}
                                        />
                                      )
                                    ),
                                }}
                                onChange={handleLoyaltyTiersChange}
                              />
                            </Form.Item>
                          </Form>
                        </Flex>
                      </Descriptions.Item>
                    </Descriptions>
                  </Space>
                </Card>
              </Space>
              <User.LoyaltyReferral userId={user.id} />
            </Flex>
          </Col>
          <Col sm={12} xs={24}>
            <Flex vertical gap={32}>
              <InternalNoteCard
                entityId={user.id}
                fetchNote={() => Promise.resolve(user.internalNote ?? null)}
                saveNote={(note) =>
                  dispatch(updateUser({ ...user, internalNote: note }))
                }
              />
              <User.DeviceList
                userId={user.id}
                whatsappPhoneId={user.whatsappPhoneId}
              />
            </Flex>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default InformationsTab
